export const addBlankChoices = (choiceList, label) => {
  // console.log([{value: -1, label: "-"}].concat(choiceList))
  return [{ value: -1, label: label !== undefined ? label : '-' }].concat(choiceList)
}